import React from 'react';
import {useSelector} from 'react-redux';
import {RootState} from 'modules';
import {IVodInfoData} from 'lib/api/vodInfo';
import Time from 'components/player/controlbar/Time';

const TimeContainer = () => {
  // const 결과 = useSelector(상태 선택 함수);
  const {playingTime, info} = useSelector((state: RootState) => ({
    playingTime: state.video.playingTime,
    info: state.vodInfo.titleFileInfo.data,
  }));

  const {response} = info as IVodInfoData;

  return (
    <Time
      playingTime={playingTime}
      totalDuration={response.info.total_duration}
    />
  );
};

export default TimeContainer;
